




































import { ISharedContent } from "@/models/shared-content.entity";
import { RefTypeMap } from "@/store/modules/refs.store";
import { Component, Prop } from "vue-property-decorator";
import BaseRef from "./BaseRef.vue";
import { IRefDetail } from "./RefsList.vue";

@Component({})
export default class RefsSharedContent extends BaseRef<ISharedContent> implements IRefDetail<ISharedContent> {
  readonly RefTypeMap = RefTypeMap;

  @Prop() item!: ISharedContent;
  @Prop({ default: false }) small!: boolean;
  @Prop({ default: false }) confirmable!: boolean;
  @Prop({ default: false }) isConfirmable!: boolean;

  get hasOpenDetailListener() {
    return Boolean(this.$listeners && this.$listeners.openDetail);
  }

  get hasClickListener() {
    return Boolean(this.$listeners && this.$listeners.click);
  }

  goToDetail() {
    this.item.goTo(this.$router).detail();
  }

  copyLinkToClipboard() {
    this.item.copyLinkToClipboard();
  }
}
